/**
 * Parse a card expiry string into its month and 4-digit year parts.
 *
 * Accepts both "MM/YY" and "MM/YYYY" input, so the result is the same
 * no matter how many times a value passes through form navigation.
 * The stored form value must never be rewritten in place — that is what
 * previously turned "10/30" into "10/2020" on a second pass.
 */
const parseCardExpiry = (value) => {
    const [rawMonth = "", rawYear = ""] = String(value ?? "").split("/");
    const month = rawMonth.trim();
    let year = rawYear.trim();

    if (year.length === 2) {
        year = `20${year}`;
    }

    return { month, year };
};

/**
 * Format a card expiry string as "MM/YY" for the masked expiry input.
 * Accepts both "MM/YY" and "MM/YYYY", so re-entering the payment step
 * never corrupts the value.
 */
const formatCardExpiryInput = (value) => {
    const { month, year } = parseCardExpiry(value);

    return `${month}/${year.slice(-2)}`;
};

export { parseCardExpiry, formatCardExpiryInput };
